export default function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}